define(["underscore"], function(__WEBPACK_EXTERNAL_MODULE__5__) { return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 7);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__5__;

/***/ }),
/* 6 */,
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(8);


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Metadata", {
  enumerable: true,
  get: function get() {
    return _addressMetadata.Metadata;
  }
});
Object.defineProperty(exports, "AddressFields", {
  enumerable: true,
  get: function get() {
    return _addressMetadata.AddressFields;
  }
});
exports.Constants = exports.AddressUtils = void 0;

var _addressMetadata = __webpack_require__(9);

var AddressUtils = _interopRequireWildcard(__webpack_require__(10));

exports.AddressUtils = AddressUtils;

var Constants = _interopRequireWildcard(__webpack_require__(12));

exports.Constants = Constants;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Metadata = exports.AddressFields = exports.RuleName = void 0;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable no-useless-escape */
const RuleName = {
  maxLength: 'maxLength',
  minLength: 'minLength',
  required: 'required',
  match: 'match'
};
exports.RuleName = RuleName;
const AddressFields = {
  Line1: 'Line1',
  Line2: 'Line2',
  Line3: 'Line3',
  Line4: 'Line4',
  City: 'City',
  StateOrProvinceName: 'StateOrProvinceName',
  PostalCode: 'PostalCode',
  CountryName: 'CountryName'
};
exports.AddressFields = AddressFields;
const defaultLine1 = {
  [RuleName.maxLength]: 512,
  [RuleName.required]: true,
  label: 'AddressControl_AddressLine1',
  visible: true,
  order: 0
};
const defaultLine2 = {
  [RuleName.maxLength]: 512,
  label: 'AddressControl_AddressLine2',
  visible: true,
  order: 1
};
const defaultLine3 = {
  [RuleName.maxLength]: 512,
  label: 'AddressControl_AddressLine3',
  visible: true,
  order: 2
};
const defaultLine4 = {
  [RuleName.maxLength]: 512,
  label: 'AddressControl_AddressLine4',
  visible: true,
  order: 3
};
const defaultCity = {
  [RuleName.maxLength]: 35,
  [RuleName.required]: true,
  label: 'AddressControl_City',
  visible: true,
  order: 4
};
const defaultStateOrProvince = {
  [RuleName.maxLength]: 50,
  label: 'AddressControl_StateOrProvince',
  visible: true,
  order: 5
};
const defaultBlockDisplayFormat = [[AddressFields.Line1], [AddressFields.Line2], [AddressFields.Line3], [AddressFields.Line4], [AddressFields.City], [AddressFields.StateOrProvinceName], [AddressFields.PostalCode], [AddressFields.CountryName]];
const optionalStateOrProvinceCountries = ['AG', 'AI', 'AS', 'AW', 'CC', 'CD', 'CK', 'CX', 'BB', 'FK', 'GF', 'GI', 'GL', 'GP', 'GU', 'KN', 'LC', 'MO', 'MP', 'MS', 'MT', 'NC', 'NF', 'NR', 'NU', 'PF', 'PM', 'PN', 'PS', 'PW', 'RE', 'RS', 'SM', 'TK', 'TL', 'TO', 'VA', 'VG', 'VI', 'WF'];
const defaultAddressForOptionalStateOrProvinceCountries = {
  Line1: defaultLine1,
  Line2: defaultLine2,
  Line3: defaultLine3,
  Line4: defaultLine4,
  City: defaultCity,
  PostalCode: {
    [RuleName.maxLength]: 10,
    [RuleName.required]: true,
    label: 'AddressControl_PostalCode',
    visible: true,
    order: 5
  },
  StateOrProvince: {
    [RuleName.maxLength]: 50,
    label: 'AddressControl_Province',
    visible: true,
    order: 6
  },
  BlockDisplayFormat: [[AddressFields.Line1], [AddressFields.Line2], [AddressFields.Line3], [AddressFields.Line4], [AddressFields.City, AddressFields.PostalCode], [AddressFields.CountryName]]
};
const optionalProvinceAndPostalCodeCountries = ['AN'];
const defaultAddressForOptionalProvinceAndPostalCodeCountries = {
  Line1: defaultLine1,
  Line2: defaultLine2,
  Line3: defaultLine3,
  Line4: defaultLine4,
  City: defaultCity,
  PostalCode: {
    [RuleName.maxLength]: 10,
    label: 'AddressControl_PostalCode',
    visible: true,
    order: 5
  },
  StateOrProvince: {
    [RuleName.maxLength]: 50,
    label: 'AddressControl_Province',
    visible: true,
    order: 6
  },
  BlockDisplayFormat: [[AddressFields.Line1], [AddressFields.Line2], [AddressFields.Line3], [AddressFields.Line4], [AddressFields.City, AddressFields.PostalCode], [AddressFields.CountryName]]
};
const optionalStateOrProvinceCountriesMetadata = optionalStateOrProvinceCountries.reduce((prev, curr) => _objectSpread(_objectSpread({}, prev), {}, {
  [curr]: defaultAddressForOptionalStateOrProvinceCountries
}), {});
const optionalProvinceAndPostalCodeCountriesMetadata = optionalProvinceAndPostalCodeCountries.reduce((prev, curr) => _objectSpread(_objectSpread({}, prev), {}, {
  [curr]: defaultAddressForOptionalProvinceAndPostalCodeCountries
}), {});

const Metadata = _objectSpread(_objectSpread(_objectSpread({
  US: {
    Line1: defaultLine1,
    Line2: defaultLine2,
    Line3: defaultLine3,
    Line4: defaultLine4,
    City: defaultCity,
    StateOrProvince: {
      [RuleName.maxLength]: 50,
      [RuleName.required]: true,
      label: 'AddressControl_State',
      visible: true,
      order: 5
    },
    PostalCode: {
      [RuleName.maxLength]: 10,
      [RuleName.required]: true,
      [RuleName.match]: '^$|^[0-9]{5}(\-[0-9]{4})?$',
      label: 'AddressControl_ZipCode',
      visible: true,
      order: 6
    },
    BlockDisplayFormat: [[AddressFields.Line1], [AddressFields.Line2], [AddressFields.Line3], [AddressFields.Line4], [AddressFields.City, ',', AddressFields.StateOrProvinceName, AddressFields.PostalCode], [AddressFields.CountryName]]
  },
  CA: {
    Line1: defaultLine1,
    Line2: defaultLine2,
    Line3: defaultLine3,
    Line4: defaultLine4,
    City: defaultCity,
    StateOrProvince: {
      [RuleName.maxLength]: 50,
      [RuleName.required]: true,
      label: 'AddressControl_Province',
      visible: true,
      order: 5
    },
    PostalCode: {
      [RuleName.maxLength]: 10,
      [RuleName.required]: true,
      [RuleName.match]: '^$|^[a-zA-Z][0-9][a-zA-Z][ ]?[0-9][a-zA-Z][0-9]$',
      label: 'AddressControl_PostalCode',
      visible: true,
      order: 6
    },
    BlockDisplayFormat: [[AddressFields.Line1], [AddressFields.Line2], [AddressFields.Line3], [AddressFields.Line4], [AddressFields.City, AddressFields.StateOrProvinceName, AddressFields.PostalCode], [AddressFields.CountryName]]
  },
  IT: {
    Line1: defaultLine1,
    Line2: defaultLine2,
    Line3: defaultLine3,
    Line4: defaultLine4,
    City: defaultCity,
    StateOrProvince: {
      [RuleName.maxLength]: 50,
      [RuleName.required]: true,
      label: 'AddressControl_ProvinceOrRegion',
      visible: true,
      order: 5
    },
    PostalCode: {
      [RuleName.maxLength]: 10,
      [RuleName.required]: true,
      [RuleName.match]: '^$|^[0-9]{5,5}$',
      label: 'AddressControl_ZipCode',
      visible: true,
      order: 6
    },
    BlockDisplayFormat: defaultBlockDisplayFormat
  },
  ES: {
    Line1: defaultLine1,
    Line2: defaultLine2,
    Line3: defaultLine3,
    Line4: defaultLine4,
    City: defaultCity,
    StateOrProvince: {
      [RuleName.maxLength]: 50,
      [RuleName.required]: true,
      label: 'AddressControl_StateOrProvince',
      visible: true,
      order: 5
    },
    PostalCode: {
      [RuleName.maxLength]: 10,
      [RuleName.required]: true,
      [RuleName.match]: '^$|^[0-9]{5,5}$',
      label: 'AddressControl_ZipCode',
      visible: true,
      order: 6
    },
    BlockDisplayFormat: defaultBlockDisplayFormat
  },
  BR: {
    Line1: defaultLine1,
    Line2: defaultLine2,
    Line3: defaultLine3,
    Line4: defaultLine4,
    City: defaultCity,
    StateOrProvince: {
      [RuleName.maxLength]: 50,
      [RuleName.required]: true,
      label: 'AddressControl_StateOrProvince',
      visible: true,
      order: 5
    },
    PostalCode: {
      [RuleName.maxLength]: 10,
      [RuleName.required]: true,
      [RuleName.match]: '^$|^[0-9]{5,5}[-][0-9]{3,3}$',
      label: 'AddressControl_ZipCode',
      visible: true,
      order: 6
    },
    BlockDisplayFormat: defaultBlockDisplayFormat
  },
  IN: {
    Line1: defaultLine1,
    Line2: defaultLine2,
    Line3: defaultLine3,
    Line4: defaultLine4,
    City: defaultCity,
    StateOrProvince: {
      [RuleName.maxLength]: 50,
      [RuleName.required]: true,
      label: 'AddressControl_StateOrProvince',
      visible: true,
      order: 5
    },
    PostalCode: {
      [RuleName.maxLength]: 10,
      [RuleName.required]: true,
      [RuleName.match]: '^$|^[0-9]{6,6}$',
      label: 'AddressControl_PostalCode',
      visible: true,
      order: 6
    },
    BlockDisplayFormat: defaultBlockDisplayFormat
  },
  AU: {
    Line1: defaultLine1,
    Line2: defaultLine2,
    Line3: defaultLine3,
    Line4: defaultLine4,
    City: defaultCity,
    StateOrProvince: {
      [RuleName.maxLength]: 50,
      [RuleName.required]: true,
      label: 'AddressControl_StateOrProvince',
      visible: true,
      order: 5
    },
    PostalCode: {
      [RuleName.maxLength]: 10,
      [RuleName.required]: true,
      [RuleName.match]: '^$|^[0-9]{4,4}$',
      label: 'AddressControl_ZipOrPostalCode',
      visible: true,
      order: 6
    },
    BlockDisplayFormat: defaultBlockDisplayFormat
  },
  CN: {
    Line1: defaultLine1,
    Line2: defaultLine2,
    Line3: defaultLine3,
    Line4: defaultLine4,
    City: defaultCity,
    StateOrProvince: {
      [RuleName.maxLength]: 50,
      [RuleName.required]: true,
      label: 'AddressControl_StateOrProvince',
      visible: true,
      order: 5
    },
    PostalCode: {
      [RuleName.maxLength]: 10,
      [RuleName.required]: true,
      [RuleName.match]: '^$|^[0-9]{6,6}$',
      label: 'AddressControl_ZipCode',
      visible: true,
      order: 6
    },
    BlockDisplayFormat: defaultBlockDisplayFormat
  },
  GB: {
    Line1: defaultLine1,
    Line2: defaultLine2,
    Line3: defaultLine3,
    Line4: defaultLine4,
    City: defaultCity,
    PostalCode: {
      [RuleName.maxLength]: 10,
      [RuleName.required]: true,
      [RuleName.match]: '^$|^([gG][iI][rR][ ]?0[aA]{2,2}|[a-zA-Z]([0-9][0-9a-zA-Z]?|[a-zA-Z][0-9][0-9a-zA-Z]?)[ ]?[0-9][a-zA-Z]{2,2})$',
      label: 'AddressControl_PostalCode',
      visible: true,
      order: 5
    },
    StateOrProvince: {
      [RuleName.maxLength]: 50,
      label: 'AddressControl_Province',
      visible: true,
      order: 6
    },
    BlockDisplayFormat: defaultBlockDisplayFormat
  },
  SG: {
    Line1: defaultLine1,
    Line2: defaultLine2,
    Line3: defaultLine3,
    Line4: defaultLine4,
    City: defaultCity,
    PostalCode: {
      [RuleName.maxLength]: 10,
      [RuleName.required]: true,
      [RuleName.match]: '^$|^[0-9]{6,6}$',
      label: 'AddressControl_PostalCode',
      visible: true,
      order: 5
    },
    StateOrProvince: {
      [RuleName.maxLength]: 50,
      label: 'AddressControl_Province',
      visible: true,
      order: 6
    },
    BlockDisplayFormat: [[AddressFields.Line1], [AddressFields.Line2], [AddressFields.Line3], [AddressFields.Line4], [AddressFields.City, AddressFields.PostalCode], [AddressFields.CountryName]]
  },
  FR: {
    Line1: defaultLine1,
    Line2: defaultLine2,
    Line3: defaultLine3,
    Line4: defaultLine4,
    PostalCode: {
      [RuleName.maxLength]: 10,
      [RuleName.required]: true,
      [RuleName.match]: '^$|^[0-9]{5,5}$',
      label: 'AddressControl_PostalCode',
      visible: true,
      order: 4
    },
    City: {
      [RuleName.maxLength]: 35,
      [RuleName.required]: true,
      label: 'AddressControl_City',
      visible: true,
      order: 5
    },
    StateOrProvince: {
      [RuleName.maxLength]: 50,
      label: 'AddressControl_Province',
      visible: true,
      order: 6
    },
    BlockDisplayFormat: [[AddressFields.Line1], [AddressFields.Line2], [AddressFields.Line3], [AddressFields.Line4], [AddressFields.PostalCode, AddressFields.City], [AddressFields.CountryName]]
  },
  SA: {
    Line1: defaultLine1,
    Line2: defaultLine2,
    Line3: defaultLine3,
    Line4: defaultLine4,
    City: defaultCity,
    StateOrProvince: defaultStateOrProvince,
    PostalCode: {
      [RuleName.maxLength]: 10,
      [RuleName.required]: true,
      [RuleName.match]: '^$|^[0-9]{5,5}$',
      label: 'AddressControl_ZipCode',
      visible: true,
      order: 6
    },
    BlockDisplayFormat: defaultBlockDisplayFormat
  },
  DK: {
    Line1: defaultLine1,
    Line2: defaultLine2,
    Line3: defaultLine3,
    Line4: defaultLine4,
    City: defaultCity,
    StateOrProvince: defaultStateOrProvince,
    PostalCode: {
      [RuleName.maxLength]: 10,
      [RuleName.required]: true,
      [RuleName.match]: '^$|^[0-9]{4,4}$',
      label: 'AddressControl_ZipCode',
      visible: true,
      order: 6
    },
    BlockDisplayFormat: defaultBlockDisplayFormat
  },
  DE: {
    Line1: defaultLine1,
    Line2: defaultLine2,
    Line3: defaultLine3,
    Line4: defaultLine4,
    City: defaultCity,
    StateOrProvince: defaultStateOrProvince,
    PostalCode: {
      [RuleName.maxLength]: 10,
      [RuleName.required]: true,
      [RuleName.match]: '^$|^[0-9]{5,5}$',
      label: 'AddressControl_ZipCode',
      visible: true,
      order: 6
    },
    BlockDisplayFormat: defaultBlockDisplayFormat
  },
  AT: {
    Line1: defaultLine1,
    Line2: defaultLine2,
    Line3: defaultLine3,
    Line4: defaultLine4,
    City: defaultCity,
    StateOrProvince: defaultStateOrProvince,
    PostalCode: {
      [RuleName.maxLength]: 10,
      [RuleName.required]: true,
      [RuleName.match]: '^$|^[1-9][0-9]{3,3}$',
      label: 'AddressControl_ZipCode',
      visible: true,
      order: 6
    },
    BlockDisplayFormat: defaultBlockDisplayFormat
  },
  CH: {
    Line1: defaultLine1,
    Line2: defaultLine2,
    Line3: defaultLine3,
    Line4: defaultLine4,
    City: defaultCity,
    StateOrProvince: defaultStateOrProvince,
    PostalCode: {
      [RuleName.maxLength]: 10,
      [RuleName.required]: true,
      [RuleName.match]: '^$|^[1-9][0-9]{3,3}$',
      label: 'AddressControl_ZipCode',
      visible: true,
      order: 6
    },
    BlockDisplayFormat: defaultBlockDisplayFormat
  },
  FI: {
    Line1: defaultLine1,
    Line2: defaultLine2,
    Line3: defaultLine3,
    Line4: defaultLine4,
    City: defaultCity,
    StateOrProvince: defaultStateOrProvince,
    PostalCode: {
      [RuleName.maxLength]: 10,
      [RuleName.required]: true,
      [RuleName.match]: '^$|^[0-9]{5,5}$',
      label: 'AddressControl_ZipCode',
      visible: true,
      order: 6
    },
    BlockDisplayFormat: defaultBlockDisplayFormat
  },
  IL: {
    Line1: defaultLine1,
    Line2: defaultLine2,
    Line3: defaultLine3,
    Line4: defaultLine4,
    City: defaultCity,
    StateOrProvince: defaultStateOrProvince,
    PostalCode: {
      [RuleName.maxLength]: 10,
      [RuleName.required]: true,
      [RuleName.match]: '^$|^([0-9]{5,5}|[0-9]{7,7})$',
      label: 'AddressControl_ZipCode',
      visible: true,
      order: 6
    },
    BlockDisplayFormat: defaultBlockDisplayFormat
  },
  KR: {
    Line1: defaultLine1,
    Line2: defaultLine2,
    Line3: defaultLine3,
    Line4: defaultLine4,
    City: defaultCity,
    StateOrProvince: defaultStateOrProvince,
    PostalCode: {
      [RuleName.maxLength]: 10,
      [RuleName.required]: true,
      [RuleName.match]: '^$|^[0-9]{3,3}[-]?([0-9]{3,3}|[0-9]{2,2})$',
      label: 'AddressControl_ZipCode',
      visible: true,
      order: 6
    },
    BlockDisplayFormat: defaultBlockDisplayFormat
  },
  NL: {
    Line1: defaultLine1,
    Line2: defaultLine2,
    Line3: defaultLine3,
    Line4: defaultLine4,
    City: defaultCity,
    StateOrProvince: defaultStateOrProvince,
    PostalCode: {
      [RuleName.maxLength]: 10,
      [RuleName.required]: true,
      [RuleName.match]: '^$|^[1-9][0-9]{3,3}[ ]?[a-zA-Z]{2,2}$',
      label: 'AddressControl_ZipCode',
      visible: true,
      order: 6
    },
    BlockDisplayFormat: defaultBlockDisplayFormat
  },
  NO: {
    Line1: defaultLine1,
    Line2: defaultLine2,
    Line3: defaultLine3,
    Line4: defaultLine4,
    City: defaultCity,
    StateOrProvince: defaultStateOrProvince,
    PostalCode: {
      [RuleName.maxLength]: 10,
      [RuleName.required]: true,
      [RuleName.match]: '^$|^[0-9]{4,4}$',
      label: 'AddressControl_ZipCode',
      visible: true,
      order: 6
    },
    BlockDisplayFormat: defaultBlockDisplayFormat
  },
  RU: {
    Line1: defaultLine1,
    Line2: defaultLine2,
    Line3: defaultLine3,
    Line4: defaultLine4,
    City: defaultCity,
    StateOrProvince: defaultStateOrProvince,
    PostalCode: {
      [RuleName.maxLength]: 10,
      [RuleName.required]: true,
      [RuleName.match]: '^$|^[0-9]{6,6}$',
      label: 'AddressControl_ZipCode',
      visible: true,
      order: 6
    },
    BlockDisplayFormat: defaultBlockDisplayFormat
  },
  SE: {
    Line1: defaultLine1,
    Line2: defaultLine2,
    Line3: defaultLine3,
    Line4: defaultLine4,
    City: defaultCity,
    StateOrProvince: defaultStateOrProvince,
    PostalCode: {
      [RuleName.maxLength]: 10,
      [RuleName.required]: true,
      [RuleName.match]: '^$|^(3[013-9]|4[0-7]|9[0-8]|[125-8][0-9])[0-9][ ]{1,1}[0-9]{2,2}$',
      label: 'AddressControl_ZipCode',
      visible: true,
      order: 6
    },
    BlockDisplayFormat: defaultBlockDisplayFormat
  },
  TW: {
    Line1: defaultLine1,
    Line2: defaultLine2,
    Line3: defaultLine3,
    Line4: defaultLine4,
    City: defaultCity,
    StateOrProvince: defaultStateOrProvince,
    PostalCode: {
      [RuleName.maxLength]: 10,
      [RuleName.required]: true,
      [RuleName.match]: '^$|^[0-9]{3,3}|[0-9]{5,5}$',
      label: 'AddressControl_ZipCode',
      visible: true,
      order: 6
    },
    BlockDisplayFormat: defaultBlockDisplayFormat
  }
}, optionalStateOrProvinceCountriesMetadata), optionalProvinceAndPostalCodeCountriesMetadata), {}, {
  default: {
    Line1: defaultLine1,
    Line2: defaultLine2,
    Line3: defaultLine3,
    Line4: defaultLine4,
    City: defaultCity,
    StateOrProvince: {
      [RuleName.maxLength]: 50,
      [RuleName.required]: true,
      label: 'AddressControl_StateOrProvince',
      visible: true,
      order: 5
    },
    PostalCode: {
      [RuleName.maxLength]: 10,
      [RuleName.required]: true,
      label: 'AddressControl_ZipOrPostalCode',
      visible: true,
      order: 6
    },
    BlockDisplayFormat: defaultBlockDisplayFormat
  }
});

exports.Metadata = Metadata;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isCityStateCountryMatch = exports.getCityStateCountryString = exports.getAddressObject = exports.findDuplicateAddresses = exports.removeDuplicateAddresses = exports.extendAddress = exports.areEqual = exports.normalizeAddress = exports.isValidBusinessName = exports.businessNameIsValid = exports.isValid = exports.validateMTConstraintOnly = exports.validateAndReturnError = exports.twoLinesFormat = exports.dropdownFormat = exports.inlineFormatWithBusinessName = exports.inlineFormat = exports.blockLinesFormat = exports.isNotEmpty = exports.exists = exports.findLatestValidatedAddress = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(5));

var _addressMetadata = __webpack_require__(9);

var _abl = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const AddressTwoLinesSeparator = ', ';
const AddressBlockLinesSeparator = ' ';
const AddressInlineSeparator = ' ';
const AddressProperties = [..._underscore.default.toArray(_addressMetadata.AddressFields), 'Id', 'Country', 'StateOrProvince'];
const {
  maxLength,
  minLength,
  required,
  match
} = _addressMetadata.RuleName;

const getMetadata = countryCode => _addressMetadata.Metadata[countryCode] || _addressMetadata.Metadata.default;

const inlineFormatOfProperties = (address, properties, _separator) => _underscore.default.reduce(properties, (memo, field) => {
  const addressField = _underscore.default.isString(address[field]) ? address[field].trim() : address[field];
  const separator = _underscore.default.isEmpty(memo) ? '' : _separator;
  return _underscore.default.isEmpty(addressField) ? memo : "".concat(memo).concat(separator).concat(addressField);
}, '');
/**
 * Find the latest(max TimeStamp) validated address(if there is) from a given nonempty address list, the logic is to keep the same result with backend(improved with O(n) solution):
 * https://msasg.visualstudio.com/Bing_Ads/_git/AnB?path=%2Fprivate%2FClientCenter%2FMT%2FSource%2FClientCenter%2FEO%2FAddress%2FCustomerAddressLoadEO.cs&version=GBmaster&line=152&lineEnd=154&lineStartColumn=38&lineEndColumn=47&lineStyle=plain&_a=contents
 * The TimeStamp got from backend is byte[8], it doesn't represent any real date, instead it means the upsert order of each record: https://docs.microsoft.com/en-us/sql/t-sql/data-types/rowversion-transact-sql?redirectedfrom=MSDN&view=sql-server-ver15
 * The algorithm used here is to construct the HEX string version of TimeStamp leading with the validated identifier(validated: 1, not: 0). So that the max string is the candidate.
 * @param {Array.<address>} addressList The given nonempty address list
 * @returns {address} Retruns the found address
 */


const findLatestValidatedAddress = addressList => _underscore.default.max(addressList, _ref => {
  let {
    IsValid,
    ValidationVersionId,
    TimeStamp
  } = _ref;
  return (_underscore.default.isBoolean(IsValid) || _underscore.default.isNumber(ValidationVersionId) ? '1' : '0') + (_underscore.default.isArray(TimeStamp) ? TimeStamp.map(byte => byte.toString(16)).join('') : '0000000000000000');
} // safe guard for no-TimeStamp address
);
/**
 * @param {object} address The address object.
 * @returns {boolean} Returns if given address object is not empty and it's country property is not empty.
 */


exports.findLatestValidatedAddress = findLatestValidatedAddress;

const _exists = address => _underscore.default.isObject(address) && !_underscore.default.isEmpty(address.Country);
/**
 * Whether the given address object is considered as not empty
 * The original code is from: https://msasg.visualstudio.com/DefaultCollection/Bing_Ads/_git/AdsAppUI?path=%2Fprivate%2FUI%2FCommon%2FMicrosoft.Advertising.Web.Mvc%2FControllers%2FBusinessAddressController.cs&version=GBmaster&line=130&lineEnd=142&lineStartColumn=9&lineEndColumn=10&lineStyle=plain&_a=contents
 * @param {object} address - The address object
 * @returns {boolean} - Returns true is the given address exists and it contains either StateOrProvince, PostalCode or City is not empty
 */


exports.exists = _exists;

const isNotEmpty = address => _exists(address) && _underscore.default.any(['StateOrProvince', 'PostalCode', 'City'], property => !_underscore.default.isEmpty(address[property]));
/**
 * @param {object} address The address object.
 * @returns {array} Returns array of string to display given address object with metadata display rules.
 */
// TODO: will refactor with React after


exports.isNotEmpty = isNotEmpty;

const _blockLinesFormat = address => {
  if (!_exists(address)) {
    return [];
  }

  const metadata = getMetadata(address.Country);

  const mapLine = line => _underscore.default.reduce(line, (memo, field) => {
    if (_underscore.default.contains(_addressMetadata.AddressFields, field)) {
      const addressField = _underscore.default.isString(address[field]) ? address[field].trim() : address[field];
      const separator = _underscore.default.isEmpty(memo) ? '' : AddressBlockLinesSeparator;
      return _underscore.default.isEmpty(addressField) ? memo : "".concat(memo).concat(separator).concat(addressField);
    }

    return "".concat(memo).concat(_underscore.default.isEmpty(memo) ? '' : field);
  }, '');

  return _underscore.default.compact(_underscore.default.map(metadata.BlockDisplayFormat, mapLine));
};
/**
 * @param {object} address The address object.
 * @returns {string} Returns display string of given address object with metadata properties.
 */


exports.blockLinesFormat = _blockLinesFormat;

const _inlineFormat = address => {
  if (!_exists(address)) {
    return '';
  }

  return _blockLinesFormat(address).join(AddressInlineSeparator);
};
/** A method to get the address as a string, in a standard address format.
 * @param {object} address The address object.
 * @returns {string} Returns string of given address object, formatted like a typical address in a form. (e.g. 'line1 line2 line3 line4 city, state postalcode country')
 */


exports.inlineFormat = _inlineFormat;

const inlineFormatWithBusinessName = address => {
  if (!_exists(address)) {
    return '';
  }

  return "".concat(address.BusinessName ? address.BusinessName + AddressTwoLinesSeparator : '').concat(_inlineFormat(address));
};
/**
 * Keep exporting this dropdownFormat to avoid breaking account-creation customer-address-selector
 * TODO: remove this util after replacing dropdownFormat with inlineFormatWithBusinessName
 */


exports.inlineFormatWithBusinessName = inlineFormatWithBusinessName;
const dropdownFormat = inlineFormatWithBusinessName;
/**
 * @param {object} address The address object.
 * @returns {array} Returns array of string to display given address object in two lines.
 */

exports.dropdownFormat = dropdownFormat;

const _twoLinesFormat = address => {
  if (!_exists(address)) {
    return [];
  }

  const line1 = inlineFormatOfProperties(address, [_addressMetadata.AddressFields.Line1, _addressMetadata.AddressFields.Line2, _addressMetadata.AddressFields.Line3, _addressMetadata.AddressFields.Line4], AddressTwoLinesSeparator);
  const line2 = inlineFormatOfProperties(address, [_addressMetadata.AddressFields.City, _addressMetadata.AddressFields.StateOrProvinceName, _addressMetadata.AddressFields.PostalCode, _addressMetadata.AddressFields.CountryName], AddressTwoLinesSeparator);
  return _underscore.default.compact([line1, line2]);
};
/**
 * Returns error object for given address
 * @param {object} address The address object to be validate.
 * @param {object} options The options.
 * @param {boolean} options.isOptional Whether address fields are required.
 * @returns {object} An object {[field]: array} that shows all errors for invalid fields, array is with object {ruleName, ruleValue}.
 */


exports.twoLinesFormat = _twoLinesFormat;

const validateAndReturnError = function validateAndReturnError(address) {
  let {
    isOptional = false
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const error = {};

  if (!_exists(address)) {
    if (isOptional) {
      return {};
    }

    return {
      Country: [{
        ruleName: required
      }]
    };
  }

  const metadata = getMetadata(address.Country);

  _underscore.default.each(metadata, (field, addressProperty) => {
    const ruleValueRequired = isOptional ? false : field[required];
    const ruleValueMaxlength = field[maxLength];
    const ruleValueMinLength = field[minLength];
    const ruleValueMatch = field[match];
    const errorList = [];
    const value = _underscore.default.isString(address[addressProperty]) && address[addressProperty].trim() || null;

    if (ruleValueRequired && _underscore.default.isEmpty(value)) {
      errorList.push({
        ruleName: required
      });
    }

    if (ruleValueMaxlength && !_underscore.default.isEmpty(value) && value.length > ruleValueMaxlength) {
      errorList.push({
        ruleName: maxLength,
        ruleValue: ruleValueMaxlength
      });
    }

    if (ruleValueMinLength && !_underscore.default.isEmpty(value) && value.length < ruleValueMinLength) {
      errorList.push({
        ruleName: minLength,
        ruleValue: ruleValueMinLength
      });
    }

    if (ruleValueMatch && !_underscore.default.isEmpty(value) && _underscore.default.isEmpty(value.match(ruleValueMatch))) {
      errorList.push({
        ruleName: match,
        ruleValue: ruleValueMatch
      });
    }

    if (!_underscore.default.isEmpty(errorList)) {
      error[addressProperty] = errorList;
    }
  });

  return error;
};
/**
 * Returns error object for given address that only validate MT contraint
 * For now we only validate maxlength for each property of billing address
 * @param {object} address The address object to be validate.
 * @returns {object} An object {[field]: array} that shows all errors for invalid fields, array is with object {ruleName, ruleValue}.
 */


exports.validateAndReturnError = validateAndReturnError;

const validateMTConstraintOnly = address => _underscore.default.chain(getMetadata(address && address.Country)).mapObject((field, addressProperty) => {
  const ruleValueMaxlength = field[maxLength];
  const value = _underscore.default.isString(address[addressProperty]) && address[addressProperty].trim();

  if (ruleValueMaxlength && !_underscore.default.isEmpty(value) && value.length > ruleValueMaxlength) {
    return [{
      ruleName: maxLength,
      ruleValue: ruleValueMaxlength
    }];
  }

  return undefined;
}).pick(_underscore.default.identity).value();
/**
 * @param {object} address The address object.
 * @param {object} options The options.
 * @param {boolean} options.isOptional Whether address fields are required.
 * @returns {boolean} Returns if every property of given address object is valid according to metadata rules.
 */


exports.validateMTConstraintOnly = validateMTConstraintOnly;

const _isValid = (address, options) => _underscore.default.isEmpty(validateAndReturnError(address, options));
/**
 * @param {string} businessName The name of the business to check for validity.
 * @param {object} options The options.
 * @param {boolean} options.isOptional Whether business name is required.
 * @returns {boolean} Returns whether the business name is valid
 */


exports.isValid = _isValid;

const businessNameIsValid = function businessNameIsValid(businessName) {
  let {
    isOptional = false
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return !_underscore.default.isEmpty(businessName) ? businessName.length < _abl.BusinessNameMaxLength : isOptional;
};
/**
 * @param {object} accountBusinessAddress The account business address object.
 * @param {object} options The options.
 * @param {boolean} options.isOptional Whether business name is required.
 * @returns {boolean} Returns true if given account business name object is valid.
 */


exports.businessNameIsValid = businessNameIsValid;

const _isValidBusinessName = function isValidBusinessName(accountBusinessAddress) {
  let {
    isOptional = false
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return _underscore.default.isObject(accountBusinessAddress) ? businessNameIsValid(accountBusinessAddress.BusinessName, {
    isOptional
  }) : isOptional;
};
/**
 * Returns an address object with normal properties and string values trimmed
 * @param {object} address The address object to be normalized.
 * @returns {object} An address object with normal properties.
 */


exports.isValidBusinessName = _isValidBusinessName;

const normalizeAddress = address => _underscore.default.chain(address).pick(AddressProperties).mapObject(field => {
  const fieldValue = _underscore.default.has(field, 'value') ? field.value : field;
  return _underscore.default.isString(fieldValue) ? fieldValue.trim() : fieldValue;
}).value();
/**
 * Returns true if the 2 addresses exist and have their field matching exactly.
 * Only the fields of the normalizedAddress are compared if forceNormalized is set to true, and falsy values (undefined, null, '') are all treated like a not existing field.
 * @param {object} address1 The first address object.
 * @param {object} address2 The second address object.
 * @param {bool} options.forceNormalized true to force addresses in param to get normalized, false otherwise.
 * @param {Array.<string>} options.propertiesToCompare properties to compare.
 * @returns {boolean} true if all field matches, false otherwise.
 */


exports.normalizeAddress = normalizeAddress;

const areEqual = function areEqual(address1, address2) {
  let {
    forceNormalized = false,
    propertiesToCompare = AddressProperties
  } = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (!_exists(address1) || !_exists(address2)) {
    return false;
  }

  const addressToCompare1 = forceNormalized ? normalizeAddress(address1) : address1;
  const addressToCompare2 = forceNormalized ? normalizeAddress(address2) : address2;

  const fieldsMatch = (field1, field2) => field1 === field2 || Boolean(field1) === false && Boolean(field2) === false;

  return _underscore.default.all(propertiesToCompare, field => fieldsMatch(addressToCompare1[field], addressToCompare2[field]));
};
/**
 * Address type definition
 * @typedef {object} address
 * @property {string} Id The id of address object.
 * @property {string} Country The country of address object.
 * @property {string} Line1 The line1 of address object.
 * @property {string} Line2 The line2 of address object.
 * @property {string} Line3 The line3 of address object.
 * @property {string} Line4 The line4 of address object.
 * @property {string} City The city of address object.
 * @property {string} StateOrProvince The state of address object.
 * @property {string} PostalCode The postal code of address object.
 * @property {string} CountryName The localiazed country name of address object.
 * @property {string} StateOrProvinceName The localiazed state name of address object.
 */

/**
 * Returns a copy of the given address object with additional utility methods.
 * @param {object} _address The address object to be extended with additional utility methods.
 * @returns {object} A copy of the extended address object.
 */


exports.areEqual = areEqual;

const extendAddress = _address => {
  const address = normalizeAddress(_address);
  return _underscore.default.defaults(address, {
    inlineFormat: () => _inlineFormat(address),
    twoLinesFormat: () => _twoLinesFormat(address),
    blockLinesFormat: () => _blockLinesFormat(address),
    exists: () => _exists(address),
    isValid: () => _isValid(address),
    isValidBusinessName: () => _isValidBusinessName(address)
  });
};
/**
 * Remove duplicate addresses based on addressFormatter from the given addressList
 * @param {Array.<address>} addressList - the given addressList
 * @param {object} options - extra options
 * @param {Array.<number>} options.includedAddressIds - the address Ids to be included in the result list
 * @param {function} options.addressFormatter - the address formatter function
 * @param {function} options.addressValidator - the address validator function that filters expected addresses
 * @returns {Array.<address>} - the deduplicate address list, with an extra 'formatted' property in each address
 */


exports.extendAddress = extendAddress;

const removeDuplicateAddresses = function removeDuplicateAddresses(addressList) {
  let {
    includedAddressIds = [],
    addressFormatter = inlineFormatWithBusinessName,
    addressValidator = isNotEmpty
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const validAddressList = _underscore.default.isFunction(addressValidator) ? _underscore.default.filter(addressList, addressValidator) : addressList;

  const includedAddresses = _underscore.default.filter(validAddressList, address => includedAddressIds.includes(address.Id));

  const formattedIncludedAddresses = includedAddresses.map(address => addressFormatter(address));
  return _underscore.default.chain(validAddressList).map(address => _objectSpread(_objectSpread({}, address), {}, {
    formatted: addressFormatter(address)
  })).reject(_ref2 => {
    let {
      Id,
      formatted
    } = _ref2;
    return formattedIncludedAddresses.includes(formatted) && !includedAddressIds.includes(Id);
  }).groupBy(address => address.formatted).map(findLatestValidatedAddress).value();
};
/**
 * Finds duplicate addresses in the given address list.
 *
 * @param {Array} addressList - The list of addresses to search for duplicates.
 * @param {Object} options - The options object.
 * @param {string} options.targetAddressId - The ID of the address to exclude from the search.
 * @param {Function} [options.addressFormatter=inlineFormatWithBusinessName] - The function to format the addresses for comparison.
 * @param {Function} [options.addressValidator=isNotEmpty] - The function to validate the addresses before searching for duplicates.
 * @returns {Array} - The list of duplicate addresses.
 */


exports.removeDuplicateAddresses = removeDuplicateAddresses;

const findDuplicateAddresses = function findDuplicateAddresses(addressList) {
  let {
    targetAddressId,
    addressFormatter = inlineFormatWithBusinessName,
    addressValidator = isNotEmpty
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const validAddressList = _underscore.default.isFunction(addressValidator) ? _underscore.default.filter(addressList, addressValidator) : addressList;

  const targetAddress = _underscore.default.findWhere(validAddressList, {
    Id: targetAddressId
  });

  const formattedTargetAddress = addressFormatter(targetAddress);
  return _underscore.default.chain(validAddressList).reject(_ref3 => {
    let {
      Id
    } = _ref3;
    return Id === targetAddressId;
  }).filter(address => addressFormatter(address) === formattedTargetAddress).value();
};
/**
 * @typedef {object} ValidatedField
 * @property {string} value The field value
 * @property {bool} isValid The validation result of the field value
 *
 * @typedef {object} ValidatedAddress
 * @property {ValidatedField} Country
 * @property {ValidatedField} Line1
 * @property {ValidatedField} Line2
 * @property {ValidatedField} Line3
 * @property {ValidatedField} Line4
 * @property {ValidatedField} City
 * @property {ValidatedField} StateOrProvince
 * @property {ValidatedField} PostalCode
 */

/**
 * TODO: Let AddressForm callback this AddressObject
 * Returns an plain address object from AddressForm callbacked validated address
 * @param {ValidatedAddress} validatedAddress - The validated address callbacked from AddressForm
 * @returns {address} - An plain address object.
 */


exports.findDuplicateAddresses = findDuplicateAddresses;

const getAddressObject = validatedAddress => _underscore.default.chain(validatedAddress).omit('isValid').mapObject(_ref4 => {
  let {
    value
  } = _ref4;
  return value;
}).value();
/**
 * Returns the city, state, country string from the given address object
 * Used only in CBV2 project
 * @param {address} address - The address object
 * @param {object} i18n - The i18n object
 * @returns {string} - The city, state, country string
 */


exports.getAddressObject = getAddressObject;

const getCityStateCountryString = function getCityStateCountryString() {
  let address = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let i18n = arguments.length > 1 ? arguments[1] : undefined;
  const {
    City,
    Country,
    CountryName
  } = address;
  const StateOrProvinceName = !_underscore.default.isEmpty(address.StateOrProvinceName) ? address.StateOrProvinceName : i18n.getString(_TL_('No state/province'));

  if (Country === 'US' && City && CountryName) {
    return "".concat(City, ", ").concat(StateOrProvinceName, ", ").concat(CountryName);
  }

  return CountryName ? "".concat(StateOrProvinceName, ", ").concat(CountryName) : '';
};
/**
 * Returns true if the two addresses have the same city, state, country
 * @param {address} address1 address object 1
 * @param {address} address2 address object 2
 * @param {object} i18n - The i18n object
 * @returns {boolean} true if city, state, country match, false otherwise
 */


exports.getCityStateCountryString = getCityStateCountryString;

const isCityStateCountryMatch = (address1, address2, i18n) => {
  const cityStateCountry1 = getCityStateCountryString(address1, i18n);
  const cityStateCountry2 = getCityStateCountryString(address2, i18n);
  return cityStateCountry1 === cityStateCountry2;
};

exports.isCityStateCountryMatch = isCityStateCountryMatch;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BusinessNameMaxLength = void 0;
const BusinessNameMaxLength = 90;
exports.BusinessNameMaxLength = BusinessNameMaxLength;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _abl = __webpack_require__(11);

Object.keys(_abl).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _abl[key];
    }
  });
});

/***/ })
/******/ ])});;
